export default __webpack_public_path__ + "circular-shape-silhouette.png";